import { FC } from 'react';
import { LabelProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

export interface TspLabelProps extends LabelProps {
  className?: string;
  richTitle?: string | TrustedHTML;
  component?: 'label' | 'legend';
}

const TspLabel: FC<TspLabelProps> = ({ field, richTitle, className, component = 'label' }) => {
  const { title, required } = field.model;
  const labelText = title || richTitle;

  const Component = component;

  if (!labelText) {
    return null;
  }

  return (
    <div
      className={classNames('mb-2 text-sm font-medium text-[var(--tsp-text-primary)]', className)}
    >
      <Component {...(component === 'label' ? { htmlFor: field.valueField.id } : {})}>
        {richTitle ? <span dangerouslySetInnerHTML={{ __html: richTitle || '' }} /> : title}
      </Component>
      {required && <span className="pl-0.5 font-medium text-[var(--tsp-text-primary)]">*</span>}
    </div>
  );
};

export default TspLabel;
